module.exports = {"StatusCode":200,"Payload":[{"status":"succeeded"}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/getPaymentIntentStatus.json
// module id = ly4C
// module chunks = 0